import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroRelatorioSaldoArmazem {
  lastSetDefault: Date;

  CB8LOTECTL: string;
  CB8PRODUTO: string;
  CB8LOCAL: string;
}

export class FiltroRelatorioSaldoArmazem {

  dados: IFiltroRelatorioSaldoArmazem;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-relatorio-saldo-armazem';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroRelatorioSaldoArmazem) => {
      if (filtro) {

        const {
          lastSetDefault,
         
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
          
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroRelatorioSaldoArmazem => {
    return {
      lastSetDefault: new Date(),
      CB8LOTECTL: '',
      CB8PRODUTO: '',
      CB8LOCAL: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
